import TransactionItemComponent from './transaction-item.component'

const TransactionItemModule = angular.module('cdbl.transaction-item', [

])
  .component('cdblTransactionItem', TransactionItemComponent)
  .name

export default TransactionItemModule
